export const HUBSPOT_DEMO_URL =
  "https://meetings-eu1.hubspot.com/pablo-maristany/permutdemo?uuid=ed6edae4-1387-435f-8407-6b34f54b5891"

export const AMPHORA_COMPANY_ID = 339n
export const SOURCE_AMPHORA = "amphora"
export const FALLBACK_CAMPAIGN_UUID = "128aff56-bb6d-4a4e-8f03-d45d3f101363"
